/**
 * One-tap Add to outreach — the vocabulary, mirrored from mb-server (mb-frontend#4638).
 *
 * `contracts/signal-enrollment-contract.json` is a committed copy of the file mb-server
 * generates from its zod schema (`npm run contracts:write` there). Nothing in this module is
 * typed by hand: the consts are the JSON, the types are the generated interfaces in
 * `types/generated/signalEnrollment.ts`. A vocabulary change lands as a regenerated file on
 * both sides, and the test beside this module fails if the two disagree.
 */

import contract from '@/contracts/signal-enrollment-contract.json';
import type { EnrollmentResponse, EnrollmentRowSummary } from '@/types/generated/signalEnrollment';

export type EnrollmentStatus = EnrollmentRowSummary['status'];
export type EnrollmentMode = EnrollmentResponse['mode'];
export type EnrollmentPersonOutcome = EnrollmentResponse['people'][number]['outcome'];
export type EnrollmentSummary = EnrollmentResponse['summary'];

export const OUTREACH_PATH_DIRECT = contract.outreach_path_direct;
export const ENROLLMENT_STATUSES = contract.enrollment_statuses as readonly EnrollmentStatus[];
export const ACTIVE_ENROLLMENT_STATUSES = contract.active_enrollment_statuses as readonly EnrollmentStatus[];
export const PERSON_OUTCOMES = contract.person_outcomes as readonly EnrollmentPersonOutcome[];
export const DIRECT_OUTREACH_SIGNAL_TYPES: readonly string[] = contract.direct_outreach_signal_types;
export const ENROLLMENT_ERROR_CODES: readonly string[] = contract.error_codes;

/** Statuses the rep can still cancel. */
export const isActiveEnrollmentStatus = (status: EnrollmentStatus): boolean => (
  ACTIVE_ENROLLMENT_STATUSES.includes(status)
);
